export const Abusive = 0
export const Sexual_Content = 1
export const Others = 2

export const all = [
    { label: 'Abusive Content', value: Abusive, translate: 'Abusive Content' },
    { label: 'Sexual Content', value: Sexual_Content, translate: 'Sexual Content' },
    { label: 'Others', value: Others, translate: 'Others' },
]
